<template>
<div class="modal fade theme-modal" id="add-address" tabindex="-1" aria-labelledby="exampleModalLabel"
     aria-hidden="true">
    <form @submit.prevent="create">

    <div class="modal-dialog modal-dialog-centered modal-fullscreen-sm-down">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{ $t('Add a new address')}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <i class="fa-solid fa-xmark"></i>
                </button>
            </div>
            <div class="modal-body">

                <alertErrors :errors="validationErrors" v-if="validationErrors"></alertErrors>

                    <div class="form-floating mb-4 theme-form-floating">
                        <input type="text" class="form-control" id="name" :class="{ 'is-invalid' : isInvalid('name')}" v-model="item.name">
                        <div class="invalid-feedback" v-if="isInvalid('name')">
                            {{  isInvalid('name') }}
                        </div>
                        <label for="name">{{ $t('Name') }}</label>
                    </div>

                    <div class="form-floating mb-4 theme-form-floating">
                        <input type="text" class="form-control" id="phone" :class="{ 'is-invalid' : isInvalid('phone')}" v-model="item.phone">
                        <div class="invalid-feedback" v-if="isInvalid('phone')">
                            {{  isInvalid('phone') }}
                        </div>
                        <label for="phone">{{ $t('Phone') }}</label>
                    </div>

<!--                    <div class="form-floating mb-4 theme-form-floating">-->

<!--                        <map-location-selector-->
<!--                            :center_latitude=24.684765434570487-->
<!--                            :center_longitude=46.69350100242792-->
<!--                            :latitude="item.location_latitude ?? 24.684765434570487"-->
<!--                            :longitude="item.location_longitude ?? 46.69350100242792"-->
<!--                            @locationUpdated="locationUpdated"-->
<!--                            @addressUpdated="addressUpdated">-->
<!--                        </map-location-selector>-->

<!--                    </div>-->
                    <div class="form-floating mb-4 theme-form-floating">

                        <select class="form-control" id="country" :class="{ 'is-invalid' : isInvalid('country')}" v-model="item.country_code">
                            <option value="" selected="" disabled="" hidden="" style="display: none;"></option>
                            <option v-for="option in form_options?.country" :value="option.code" >{{ option.name }}</option>
                        </select>

                        <div class="invalid-feedback" v-if="isInvalid('country')">
                            {{  isInvalid('country') }}
                        </div>
                        <label for="country">{{ $t('Country') }}</label>
                    </div>

                    <div class="form-floating mb-4 theme-form-floating">

                        <select class="form-control" id="city" :class="{ 'is-invalid' : isInvalid('city')}" v-model="item.city_id">
                            <option value="" selected="" disabled="" hidden="" style="display: none;"></option>
                            <option v-for="option in form_options?.city" :value="option.id" >{{ option.name }}</option>
                        </select>

                        <div class="invalid-feedback" v-if="isInvalid('city')">
                            {{  isInvalid('city') }}
                        </div>
                        <label for="country">{{ $t('City') }}</label>
                    </div>

                    <div class="form-floating mb-4 theme-form-floating">
                        <input type="text" class="form-control" id="address" :class="{ 'is-invalid' : isInvalid('address')}" v-model="item.address">
                        <div class="invalid-feedback" v-if="isInvalid('address')">
                            {{  isInvalid('address') }}
                        </div>
                        <label for="address">{{ $t('Address') }}</label>
                    </div>

                    <div class="form-floating mb-4 theme-form-floating">
                        <input type="text" class="form-control" id="postal_code" :class="{ 'is-invalid' : isInvalid('postal_code')}" v-model="item.postal_code">
                        <div class="invalid-feedback" v-if="isInvalid('postal_code')">
                            {{  isInvalid('postal_code') }}
                        </div>
                        <label for="postal_code">{{ $t('Postal code') }}</label>
                    </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary btn-md" data-bs-dismiss="modal">{{ $t('Cancel') }}</button>
                <button type="submit" class="btn theme-bg-color btn-md text-white">
                    {{ $t('Save') }}
                </button>
            </div>
        </div>
    </div>
    </form>

</div>
</template>

<script>

import { useToast } from "vue-toastification";
const toast = useToast();

import alertErrors from "../handling/alert-errors";

import mapLocationSelector from "./map-location-selector";

export default {
    components: {
        alertErrors,
        mapLocationSelector,
    },
    data() {
        return {
            form_options: null,
            item: {},
            validationErrors: null,
        }
    },
    created() {

        const that = this;

        setTimeout(function () {
                $('#add-address').on('shown.bs.modal', function () {

                    if(that.form_options == null ){
                        const id = toast.info(that.$t('getting options ...'),{ icon: 'fa-light fa-filter-list'  });
                        axios.get('addresses/create').then(response => {
                            toast.dismiss(id);
                            that.form_options = response.data.elements;
                        }) .catch(function (error) {
                            toast.dismiss(id);
                            if (error.response) {
                                that.validationErrors = error.response.data.errors ;
                            }
                        });
                    }

                })
        }, 1 );

    },
    methods: {
        // locationUpdated(latlng) {
        //     this.item.location_latitude = latlng?.lat;
        //     this.item.location_longitude = latlng?.lng;
        // },
        // addressUpdated(address , isOnCreating) {
        //
        //     if(isOnCreating === false){
        //
        //         this.map_address = address;
        //
        //         if( address?.country?.short_name != null ){
        //             this.item.country_code = address?.country?.short_name ;
        //         }
        //         this.item.neighborhood_name =
        //             // ( address?.administrative_area_level_1?.short_name ?? '' ) + ' ' +
        //             // ( address?.administrative_area_level_2?.short_name ?? '' ) + ' ' +
        //             ( address?.administrative_area_level_3?.short_name ?? '' ) + ' ' +
        //             ( address?.sublocality_level_1?.short_name ?? '' ) + ' ' +
        //             ( address?.locality?.short_name ?? '' ) + ' '+
        //             ( address?.route?.short_name ?? '' ) + ' ';
        //
        //         this.getCityFromAddress(address);
        //     }
        // },
        // getCityFromAddress(address) {
        //     console.log(address);
        //     this.item.city_id = null;
        //     const object = this.form_options?.city;
        //     for (const property in object) {
        //         if(
        //             object[property]?.name == address?.administrative_area_level_1?.short_name
        //             ||
        //             object[property]?.name == address?.administrative_area_level_2?.short_name
        //             ||
        //             object[property]?.name == address?.sublocality_level_1?.short_name
        //             ||
        //             object[property]?.name == address?.locality?.short_name
        //             ||
        //             object[property]?.name == address?.route?.short_name
        //         ) {
        //             this.item.city_id = object[property]?.id;
        //         }
        //     }
        // },
        isInvalid( name ) {
            return this.validationErrors != null ? this.validationErrors[name]?.join() : false;
        },
        create() {

            const id = toast.info(this.$t('Adding content...'),{ icon: 'fa-solid fa-cloud-arrow-up'  });

            const that = this;
            this.validationErrors = null;


            let formData = new FormData();
            Object.entries(this.item).forEach(([key, value]) => {
                formData.append(key, value);
            });

            axios.post('addresses',
                formData
            ).then(response => {
                toast.dismiss(id);

                toast.success(response.data.message  ,{
                    timeout: 3000,
                },{ icon: 'fa-solid fa-circle-check'  });

                this.item = {};


                $('#add-address').modal('hide');

                this.$emit('add' , response.data?.data);

            }) .catch(function (error) {
                toast.dismiss(id);
                if (error.response) {
                    that.validationErrors = error.response.data.errors ;
                    toast.error(error.response.data.message  ,{
                        timeout: 3000,
                    },{ icon: 'fa-solid fa-circle-exclamation'  });
                }
            });

        }
    }
}
</script>
